(() => {
  const SELECTOR = "[data-home-testimonials]";

  const initializeSection = (section) => {
    if (!section || section.dataset.testimonialsInitialized === "true") return;

    const track = section.querySelector("[data-testimonials-track]");
    const current = section.querySelector("[data-testimonials-current]");
    const previousButton = section.querySelector("[data-testimonials-prev]");
    const nextButton = section.querySelector("[data-testimonials-next]");
    const slides = track ? Array.from(track.children) : [];

    if (!track || !current || !previousButton || !nextButton || slides.length < 2) return;

    section.dataset.testimonialsInitialized = "true";

    let index = 0;
    let autoplayId = null;

    const render = () => {
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      current.textContent = String(index + 1).padStart(2, "0");
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      render();
    };

    const next = () => goTo(index + 1);
    const previous = () => goTo(index - 1);

    const stopAutoplay = () => {
      if (autoplayId) window.clearInterval(autoplayId);
      autoplayId = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayId = window.setInterval(next, 4200);
    };

    previousButton.addEventListener("click", () => {
      previous();
      startAutoplay();
    });

    nextButton.addEventListener("click", () => {
      next();
      startAutoplay();
    });

    section.addEventListener("mouseenter", stopAutoplay);
    section.addEventListener("mouseleave", startAutoplay);
    section.addEventListener("focusin", stopAutoplay);
    section.addEventListener("focusout", startAutoplay);

    render();
    startAutoplay();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initializeSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
